var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform_view_container"},[(_vm.pathName)?_c(_vm.navigation[_vm.pathName],{tag:"component"}):_vm._e(),_c('div',{class:_vm.navigation[_vm.pathName] ? 'container' : 'platform_view_container'},[_c('Header',{attrs:{"hamburgerProps":!!_vm.navigation[_vm.pathName]}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }